import { handleActions } from 'redux-actions';
import { Actions, storeLoginUrl } from 'actions/shellActions';
import { AnyAction } from 'redux';

export type State = Readonly<{
    language: string;
    confirm: string | null;
    loginUrl: string | null;
}>;

export const initialState = Object.freeze<State>({
    language: '',
    confirm: null,
    loginUrl: null,
});

// handle other app state changes that need to happen in forms
export const shellReducer = handleActions({
    [Actions.SHOW_CONFIRMATION]: (state: State, action: AnyAction) => {
        return { ...state, confirm: action.payload };
    },
    [Actions.HIDE_CONFIRMATION]: (state: State) => {
        return { ...state, confirm: null };
    },
    [Actions.SET_LANGUAGE]: (state: State, action: AnyAction) => {
        return { ...state, language: action.payload };
    },
    [Actions.STORE_LOGIN_URL]: (state: State, action: ReturnType<typeof storeLoginUrl>) => {
        return { ...state, loginUrl: action.payload };
    },
}, initialState);
